import { cloneDeep, get } from 'lodash';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getRegionVariable<T = any>(key: string, defaultValue?: T): T {

  let regionConfig;

  if (process.env.NUXT_ENV_IS_NEXT_ENVIRONMENT === 'true') {
    regionConfig = window.regionConfig;
  }
  else {
    if (process.env.NUXT_ENV_REGION_CONFIG_JSON === undefined) {
      throw new ReferenceError('The "NUXT_ENV_REGION_CONFIG_JSON" environment variable must be defined')
    }

    if (process.env.NUXT_ENV_REGION_CONFIG_JSON === '') {
      throw new ReferenceError('The "NUXT_ENV_REGION_CONFIG_JSON" environment variable must be a raw JSON string')
    }

    try {
      regionConfig = JSON.parse(process.env.NUXT_ENV_REGION_CONFIG_JSON);
    }

    catch (error) {
      throw new Error('The "NUXT_ENV_REGION_CONFIG_JSON" environment variable is set but not parsable as JSON')
    }
  }

  const variable = cloneDeep(get(regionConfig, key));

  if (variable === undefined) {
    // WL-4568 Temporary solution
    console.warn(`Missing '${key}' in region config object`);
    // @ts-expect-error - default value could be undefined and the return type does not handle this.
    return defaultValue;
  }

  return variable as T;
}
